<template>
  <div class="reset page-common-style">
      <el-row :gutter="20" class="reset-wraps">
          <el-col :span="8" class="reset-lefts">
            <img src="@/assets/password.png" alt="">
          </el-col>
          <el-col :span="16" class="reset-rights">
              <!-- <h3></h3> -->
              <p>
                请在下面的输入框中输入对应密码，然后点击“保存”修改您的登陆密码为最新的密码。为了保证您的账号安全，请不要将您的密码告诉给第三方，并建议您不定期修改您的登录密码
              </p>
              <el-form ref="formPhone" :model="loginPhone" :rules="rules" class="form-content">
                  <el-form-item>
                    <el-input v-model="loginPhone.phone" :disabled="loginPhone.phone != ''" prefix-icon="el-icon-user-solid"></el-input>
                  </el-form-item>

                  <el-form-item prop="newPassword">
                    <el-input v-model="loginPhone.newPassword" show-password placeholder="请输入新密码，密码格式数字、英文字母、特殊符号，8位数以上" prefix-icon="el-icon-lock"></el-input>
                  </el-form-item>
                  <!-- <div class="password-mj" style="margin-bottom:10px;" v-show="showSetOpenPassWordGrade">
                      安全等级 &nbsp; &nbsp;
                      <span :class="'span'+setOpenPassWordGrade" v-for="(item,index) in 5" :key="index"></span>
                      &nbsp; &nbsp; {{ setOpenPassWordGrade==1?'弱': setOpenPassWordGrade==3?'中':'强' }}
                  </div> -->
                
                  <el-form-item prop="confirmPassword">
                    <el-input v-model="loginPhone.confirmPassword" show-password placeholder="请再次输入密码" prefix-icon="el-icon-lock"></el-input>
                  </el-form-item>
                  <!-- <div class="password-mj password-bottom" v-show="showConfirmOpenPassWordGrade">
                      安全等级 &nbsp;
                      <span :class="'span'+confirmOpenPassWordGrade" v-for="(item,index) in 5" :key="index"></span>
                      &nbsp; &nbsp; {{ confirmOpenPassWordGrade==1?'弱': confirmOpenPassWordGrade==3?'中':'强' }}
                  </div> -->

                  <el-form-item class="submit">
                      <el-button class="btn-login" type="primary" @click="resetPwd">保存</el-button>
                  </el-form-item>
              </el-form>
          </el-col>
      </el-row>
  </div>
</template>

<script>
import { manageAPI } from 'liankong-ui-api'
  import { Store } from '@/utils/LocalCache.js'
export default {
data() {
    var validatePass = (rule, value, callback) => {
      const passwordCheck = /^(?=.{8})(?=.*?[a-zA-Z])(?=.*?\d)(?=.*?[*?!&￥$%^#,./@";:><\[\]}{\-=+_\\|》《。，、？’‘“”~ `]).*$/;
          if (value === '') {
              /* 不显示安全等级*/
              this.showSetOpenPassWordGrade = false;

              callback(new Error('请输入密码'));
          } else if(!passwordCheck.test(value)){
            this.showSetOpenPassWordGrade = false;

            callback(new Error('密码中必须包含数字、英文字符、特殊符号，8位数以上'));
          } else {
              /* 显示安全等级*/
              this.showSetOpenPassWordGrade = true;
              if (this.passwordRules(this.loginPhone.newPassword)==4) {
                  /*赋值安全等级 高*/
                  this.setOpenPassWordGrade = 5
              } else if (this.passwordRules(this.loginPhone.newPassword)>2 && this.passwordRules(this.loginPhone.newPassword)<4) {
                  /*赋值安全等级 中*/
                  this.setOpenPassWordGrade = 3
              } else if (this.passwordRules(this.loginPhone.newPassword)<3) {
                  /*赋值安全等级 低*/
                  this.setOpenPassWordGrade = 1
              }

              if (this.loginPhone.confirmPassword !== '') {
                  this.$refs.formPhone.validateField('confirmPassword');
              }
              callback();
          }
      };
      var validatePass2 = (rule, value, callback) => {
        const password2Check = /^(?=.{8})(?=.*?[a-zA-Z])(?=.*?\d)(?=.*?[*?!&￥$%^#,./@";:><\[\]}{\-=+_\\|》《。，、？’‘“”~ `]).*$/;
        if (value === '') {
            /* 不显示安全等级*/
            this.showConfirmOpenPassWordGrade = false;

            callback(new Error('请再次输入密码'));
        } else if (value !== this.loginPhone.newPassword) {
            /* 不显示安全等级*/
            this.showConfirmOpenPassWordGrade = false;

            callback(new Error('两次输入密码不一致!'));
        } else if(!password2Check.test(value)){
          this.showConfirmOpenPassWordGrade = false;
          callback(new Error('密码中必须包含数字、英文字符、特殊符号，8位数以上!'));
        } else {
            /* 显示安全等级*/
            this.showConfirmOpenPassWordGrade = true;
            if (this.passwordRules(this.loginPhone.confirmPassword)==4) {
                /*赋值安全等级 高*/
                this.confirmOpenPassWordGrade = 5
            } else if (this.passwordRules(this.loginPhone.confirmPassword)>2 && this.passwordRules(this.loginPhone.confirmPassword)<4) {
                /*赋值安全等级 中*/
                this.confirmOpenPassWordGrade = 3
            } else if (this.passwordRules(this.loginPhone.confirmPassword)<3) {
                /*赋值安全等级 低*/
                this.confirmOpenPassWordGrade = 1
            }

            callback();
        }
  };
  return {
      loginPhone: {
        phone: "",
        newPassword: "",
        confirmPassword:''
      },
      loading: {
        send: false,
      },
      codeContent: "获取验证码",
      timerRunning: false,
      rules: {
        newPassword: [
          { required: true, validator: validatePass, trigger: 'blur' },
          { min: 8, message: '密码长度在8位以上', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validatePass2, trigger: 'blur' },
          { min: 8, message: '密码长度在8位以上', trigger: 'blur' }
        ],
      },
      access_token:'',
      showSetOpenPassWordGrade: false,
      setOpenPassWordGrade: '', // 设置校验安全等级
      showConfirmOpenPassWordGrade: false,
      confirmOpenPassWordGrade: '', // 确认密码校验安全等级
    };
  },
  computed: {},
  methods: {
    //发送验证码
    sendSMSCode() {
      this.$refs['formPhone'].validate((valid) => {
        if (valid) {
          manageAPI.toolSendLoginCode(this.loginPhone.phone,this.access_token).then(res=>{
            this.loading.send = false;
            this.countDownChange();
          }).catch(err=>{
            this.loading.send = false;
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //倒计时
    countDownChange() {
      let number = 60;
      this.timerRunning = true;
      this.loading.send = false;
      this.codeContent = "60S后重新获取";
      let timer = setInterval(() => {
        if (number > 1) {
          number--;
          this.codeContent = number + "S后重新获取";
          return true;
        } else {
          number = 60;
          clearInterval(timer);
          this.codeContent = "获取验证码";
          this.timerRunning = false;
          return false;
        }
      }, 1000);
    },
    //修改密码
    resetPwd() {
        this.$refs['formPhone'].validate((valid) => {
          if (valid) {
            manageAPI.toolResetPassword(this.loginPhone.newPassword, this.access_token).then(res=>{
              if (res.code == 0) {
                this.$message.success('密码修改成功')
                this.$store.state.login.token=null
                this.$router.replace({
                  path: '/login'
                });

              }else{
                //登录失败重置倒计时重新登录需做
                this.$message.error(data.message);
              }
            }).catch(err=>{
              this.$message.error(res.message);
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      
    },

    // 密码安全等级判断
    passwordRules(password){
        let passwordCount = 0
        const smallLetter = /[a-z]/; //小写字母
        const bigLetter = /[A-Z]/; //大写字母
        const digit = /[0-9]/; // 数字
        const specialLetter = /[._~!@#$^&*]/; // 特殊字母
        if(password.match(specialLetter)) {
            passwordCount++
        }
        if(password.match(smallLetter)){
            passwordCount++
        }
        if(password.match(bigLetter)){
            passwordCount++
        }
        if(password.match(digit)){
            passwordCount++
        }
        return passwordCount
    },
  },
  created() {
  },
  mounted(){
      this.loginPhone.phone = this.$store.state.login.phoneNumber;
      this.access_token = Store.get('access_token');
  }
};
</script>

<style lang='less' scoped>
.form-content {
  width: 500px;
  // margin-left: 20px;
  padding-bottom: 20px;
}
.box-card {
  border: none;
}
.submit {
  text-align: center;
}

.reset-wraps {
  display: flex;
  padding-top: 88px;
  .reset-lefts {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    img {
      width: 400px;
      // height: 303px;
    }
  }
  .reset-rights {
    h3 {
      margin: 0px;
      padding: 0px;
      position: relative;
      &::before {
        content: '';
        width: 5px;
        height: 20px;
        background: #409EFF;
        position: absolute;
        left: 0px;
        top: 4px;
      }
      padding-left: 15px;
    }
    p {
      width: 80%;
      color: #737B8B;
      font-size: 14px;
      line-height: 22px;
      margin: 20px 0 30px 0;
    }
    .el-form {
      .el-form-item {
        margin-bottom: 30px;
      }
    }
  }
}
</style>